import { useLocation, useNavigate } from 'react-router-dom'

import { DirectTask } from '@frame/lib/api/tasks/types'
import { useRootContext } from '@frame/lib/context'
import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'
import { useStrategies } from '@frame/lib/hooks/useStrategies'
import { useCachedInfoStore } from '@frame/lib/stores/useCachedInfoStore'
import { useStore } from '@frame/lib/stores/useStore'
import { routes } from '@frame/routes'

export function useDocumentNavigation({ task, resetDropzone }: { task?: DirectTask; resetDropzone: () => void }) {
  const navigate = useNavigate()
  const location = useLocation()

  const { mutateAndNavigate } = useAutoNavigate()
  const { actions } = useRootContext()
  const { bankEnabled, credentialsEnabled } = useStrategies()
  const { removeAllFiles } = useCachedInfoStore(({ removeAllFiles }) => ({
    removeAllFiles,
  }))
  const { docsForMortgageEnabled } = useStore(({ session }) => ({
    docsForMortgageEnabled: session?.configuration.docs_for_mortgage_enabled,
  }))

  function handleBack() {
    removeAllFiles()
    resetDropzone()
    navigate(-1)
  }

  async function handleNoPaystubs() {
    if (task?.is_external_employment && !docsForMortgageEnabled) {
      await actions.skipDirectTask(task.id)
      mutateAndNavigate()
    } else {
      if (bankEnabled) {
        mutateAndNavigate()
      } else {
        const params = new URLSearchParams(location.search)
        params.set('q', params.get('employerName') || '')
        const confirmEmployerPath = task?.id ? `${routes.confirmEmployer}/${task.id}` : routes.confirmEmployer
        navigate(`${confirmEmployerPath}?${params.toString()}`, {
          state: {
            fromDocsForMortgage: docsForMortgageEnabled && credentialsEnabled,
          },
        })
      }
    }
  }

  return {
    handleBack,
    handleNoPaystubs,
  }
}
